<template>
    <div class="maincontainer">
        <div
            class="row"
            style="position: fixed;
                   top: 100px;
                   left: 0px;
                   z-index: 33;
                   background-color: white;
                   padding-top: 25px;
                   padding-bottom: 25px;
                   width: 100%;"
                    v-if="role == 'ddd_admin' || (role == 'ddd_worker' && extended_privileges)"
        >
            <div class="col s6 m8 l10"></div>
            <div class="col s6 m4 l2" style="text-align: right;">
                <a class="waves-effect waves-light btn" v-on:click="addCustomer()">{{ $t('customers.add') }}</a>
            </div>
        </div>
        <table>
            <thead>
                <tr>
                    <th class='number cursor-pointer' v-on:click="set_order('number')" style="width: 7%;">
                        <span>{{$t('customers.number')}}</span>
                        <i class="material-icons dp6" v-if="orderby == 'number' && order == 'desc'">arrow_drop_down</i>
                        <i class="material-icons dp6" v-if="orderby == 'number' && order == 'asc'">arrow_drop_up</i>
                        <div class="input-field col s6">
                            <input id="number" type="text" class="validate" v-model="numbersearch">
                        </div>
                    </th>
                    <th class='name cursor-pointer' v-on:click="set_order('name')" style="width: 40%;">
                        <span>{{$t('customers.name')}}</span>
                        <i class="material-icons dp6" v-if="orderby == 'name' && order == 'desc'">arrow_drop_down</i>
                        <i class="material-icons dp6" v-if="orderby == 'name' && order == 'asc'">arrow_drop_up</i>
                        <div class="input-field col s6">
                            <input id="name" type="text" class="validate" v-model="customersearch">
                        </div>
                    </th>
                    <th class='address_text cursor-pointer' v-on:click="set_order('address_text')" style="width: 25%;">
                        <span>{{$t('customers.address')}}</span>
                        <i class="material-icons dp6" v-if="orderby == 'address_text' && order == 'desc'">arrow_drop_down</i>
                        <i class="material-icons dp6" v-if="orderby == 'address_text' && order == 'asc'">arrow_drop_up</i>
                        <div class="input-field col s6">
                            <input id="address" type="text" class="validate" v-model="addresssearch">
                        </div>
                    </th>
                    <th class='nip cursor-pointer' v-on:click="set_order('nip')" style="width: 5%;">
                        <span>{{$t('customers.nip')}}</span>
                        <i class="material-icons dp6" v-if="orderby == 'nip' && order == 'desc'">arrow_drop_down</i>
                        <i class="material-icons dp6" v-if="orderby == 'nip' && order == 'asc'">arrow_drop_up</i>
                        <div class="input-field col s6">
                            <input id="nip" type="text" class="validate" v-model="nipsearch">
                        </div>
                    </th>
                    <th class='tags cursor-pointer' style="width: 10%;">
                        <span v-on:click="set_order('tags')">{{$t('customers.tags')}}</span>
                        <i class="material-icons dp6" v-if="orderby == 'tags' && order == 'desc'">arrow_drop_down</i>
                        <i class="material-icons dp6" v-if="orderby == 'tags' && order == 'asc'">arrow_drop_up</i>
                        <div class="input-field col s12">
                            <selector v-model="selectedTags" :items="tags" identifier="tagslist"></selector>
                        </div>
                    </th>
                    <th class="statuses cursor-pointer" v-on:click="set_order('status')" style="width: 13%;" >
                        <span>{{$t('customers.status')}}</span>
                        <i class="material-icons dp6" v-if="orderby == 'status' && order == 'asc'">arrow_drop_down</i>
                        <i class="material-icons dp6" v-if="orderby == 'status' && order == 'desc'">arrow_drop_up</i>
                        <div class="input-field col s12">
                            <selector v-model="status" :items="listStatuses" identifier="statuses"></selector>
                        </div>
                    </th>
                </tr>
            </thead>
            <tbody v-if="loaded">
                <template v-for="(customer, index) in listItems">
                    <tr class="customer" v-on:click="collapse(customer)" @dblclick="showCustomer(customer)" v-bind:class="redme(customer)" style="cursor: pointer;">
                        <td style="width: 7%;">
                            <div>{{customer.number}}</div>
                        </td>
                        <td style="width: 40%;">
                            <div>{{customer.name}}</div>
                        </td>
                        <td style="width: 20%; font-size: 12px;">
                            <div>{{customer.address.street}} {{customer.address.postal_code}} {{customer.address.city}}</div>
                        </td>
                        <td style="width: 10%; font-size: 12px;">
                            <div>{{customer.nip}}</div>
                        </td>
                        <td style="width: 10%; font-size: 12px;">
                            <div>{{customer.tags.join(",")}}</div>
                        </td>
                        <td style="width: 13%; font-size: 12px;">
                            <div style="padding-left: 5px;">{{customer.status == "active" ? $t('customers.status_active') : $t('customers.status_inactive')}}</div>
                        </td>
                    </tr>
                    <tr v-if="customer.collapsed" style="border-bottom-width: 5px;">
                        <td colspan="6">
                            <subplaces v-bind:customer_id="customer.id" :role="role" :extended_privileges="extended_privileges"/>
                        </td>
                    </tr>
                </template>
            </tbody>
            <preloader v-if="loaded == false" n="6" />
        </table>
        <template v-if="listItems.length == 0 && loaded == true"><p style="font-size: 12px;">{{$t('customers.not_found')}}</p></template>
    </div>
</template>
<script>
import Vue2Filters from 'vue2-filters'
import axios from 'axios';
import _ from 'lodash';
export default {
    props: {
        page: String,
        role: String,
        extended_privileges: Boolean
    },
    data: function() {
        return {
            order: 'asc',
            orderby: 'number',
            customers: [],
            loaded: false,
            status: ['active'],
            selectedTags: [],
            tags: [],
            customersearch: "",
            numbersearch: "",
            nipsearch: "",
            addresssearch: "",
            curcust: null
        }
    },
    created() {
        this.fetch_customers();
    },
    mounted(){
    },
    methods: {
        fetch_customers: function() {
            axios.get('/customers.json').then(response => {
                this.customers = response.data;

                for (var customer of this.customers) {
                    customer.keywords = _([customer.name, customer.places.map(function(place){return place.name})]).flatten().join(" ");
                    if (_.isNull(customer.address) == false && _.isUndefined(customer.address) == false) {
                        customer.address_text = "" + customer.address.street + " " + customer.address.city
                    } else {
                        customer.address = {};
                        customer.address_text = "";
                    }

                    customer.collapsed = false;
                    this.tags = _.union(this.tags, customer.tags)
                }
                this.loaded = true;
                this.init_selectors();
            }).catch(e =>{
            })
        },
        collapse: function(customer) {
            customer.collapsed = !(customer.collapsed)
            if (this.curcust?.id != customer.id){
                if(this.curcust != null){
                    this.curcust.collapsed = false
                }
                this.curcust = null
            }
            this.curcust = customer
            this.$forceUpdate();
        },
        set_order: function(order) {
            if (this.orderby == order) {
                if (this.order == 'desc') {
                    this.order = 'asc'
                } else if (this.order == 'asc') {
                    this.order = 'desc'
                }

            } else {
                this.orderby = order;
            }
        },
        init_selectors: function() {
            var elemss = document.querySelectorAll('.selectwrapper .dropdown-trigger');
            M.Dropdown.init(elemss, { closeOnClick: false });
        },
        addCustomer() {
            this.$router.push('/customers/new');
        },
        redme(customer) {
            return { 'reded': customer.collapsed }
        },
        showCustomer(customer) {
            this.$router.push('/customers/' + customer.id);
        }
    },
    computed: {
        listItems() {
            var that = this;
            return _.filter(
                _.orderBy(this.customers, this.orderby, this.order),
                function(item) {
                    var statusMatch = (_.includes(that.status, item.status) || that.status.length == 0);
                    var keywordsMatch = item.keywords.toUpperCase().indexOf(that.customersearch.toUpperCase()) >= 0;
                    var numberMatch = item.number.toUpperCase().indexOf(that.numbersearch.toUpperCase()) >= 0;
                    var addressMatch = item.address_text.toLowerCase().indexOf(that.addresssearch.toLowerCase()) >= 0;
                    var nipMatch = item.nip.toLowerCase().indexOf(that.nipsearch.toLowerCase()) >= 0;
                    var tagsMatch = (_.intersection(that.selectedTags, item.tags).length > 0 || that.selectedTags.length == 0);
                    return statusMatch && keywordsMatch && numberMatch && addressMatch && tagsMatch && nipMatch;
                }
            );
        },
        listStatuses(){
            return [
                { name: this.$t('customers.status_active'), value: 'active' },
                { name: this.$t('customers.status_inactive'), value: 'inactive' },
                { name: this.$t('customers.status_suspended'), value: 'suspended' }
            ]
        }
    },
    mixins: [Vue2Filters.mixin],
}
</script>
<style scoped>
.login_button {
    color: red;
}

p {
    font-size: 2em;
    text-align: center;
}

nav {
    background-color: #626262;
    height: 50px;
}

nav a {
    margin: 15px;
}

.btn-large,
.btn {
    border-radius: 8px !important;
    color: black;
    background-color: #00CC66;
    width: 200px;
    height: 40px;
    font-size: 20px;
}

table {
    margin-top: 75px;
    position: relative;
}

thead th {
    font-weight: 300;
    padding-top: 5px;
    padding-bottom: 5px;
}

thead .input-field {
    margin-top: unset;
    margin-bottom: unset;
}

thead {
    background-color: #DADADA;
}

th span {
    padding-left: 5px;
}

.maincontainer {
    padding-top: 10px;
    margin: 15px;
}

.reded {
    border-color: rgb(194, 32, 38);
    border-top: 4px solid rgb(194, 32, 38);
    border-bottom: 4px solid rgb(194, 32, 38);
    /*border-right: 0px solid rgb(194, 32, 38);*/
}

tr td {
    padding-left: 15px;
}

.reded td {
    border-top: 4px solid rgb(194, 32, 38);
    border-bottom: 4px solid rgb(194, 32, 38);
    border-radius: 0px;
}

.reded td:first-child {
    border-left: 4px solid rgb(194, 32, 38);
}

.reded td:last-child {
    border-right: 4px solid rgb(194, 32, 38);
}

.row {
    margin-bottom: 15px !important;
}

.select-wrapper {
    margin-left: 0px;
}

table {
    border-collapse: collapse;
    border-spacing: 0 1em;
}

/deep/ .select-wrapper {
    margin-left: 0px;
}

thead>tr>th {
    position: sticky;
    top: 180px;
    background-color: #DADADA;
}

/deep/ ul#dropdownselectorstatuses label span {
    padding-left: 30px;
}

/deep/ .statuses input {
    font-size: 10px !important;
}
</style>